<template>

  <div v-if="application_status.loaded">

      <group-card title="Loan Details" icon="description">

        <group-card-row title="Requested Loan">
          <template v-slot:content>

            <div class="md-layout-item md-size-100" >

              <div class="property-list">

                <property-view name="Loan Type">
                  {{ application.loan.type }}
                </property-view>
                <br>
                <property-view name="Amount">
                  {{ requested_amount | currency }}
                </property-view>
                <br>
                <property-view name="Term">
                  {{ application.loan.requested.term }} months
                </property-view>
                <br>
                <property-view name="Affordability">
                  {{ toMonthlyAmount(application.loan.affordability.amount, application.loan.affordability.frequency) | currency }} / m
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content></template>
          <template v-slot:validation>

             <property-view name="Total">
              {{ toMonthlyAmount(application.loan.affordability.amount, application.loan.affordability.frequency) | currency }} / m
             </property-view>

          </template>

        </group-card-row>
        <!-- <group-card-row title="Offered Loan">
          <template v-slot:content>

            <div class="md-layout-item md-size-100" >

              <div class="property-list">
                <property-view name="Rate">
                  {{ application.loan.offered.interest_rate }}%
                </property-view>
                <br>
                <property-view name="Amount">
                  {{ application.loan.offered.amount | currency }}
                </property-view>
                <br>
                <property-view name="Term">
                  {{ application.loan.offered.term }} months
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row> -->

        <group-card-row title="Asset">
          <template v-slot:content>

            <div class="property-list">
              <property-view name="Type">
                {{ application.loan.asset.type }}
              </property-view>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row :title="application.loan.asset.type">
          <template v-slot:content>
            <div class="property-list">
              <property-view  name="Sale Type">
                <template>
                 {{ options.assets_sale_types[security.private_sale-1] }}
                </template>
              </property-view>
              <property-view  name="Supplier Name" v-if="security.supplier_name">
                {{ security.supplier_name }}
              </property-view>
              <property-view  name="Supplier Phone" v-if="security.supplier_contact_number">
                {{ security.supplier_contact_number }}
              </property-view>
              <property-view  name="Supplier Email" v-if="security.supplier_contact_email">
                {{ security.supplier_contact_email }}
              </property-view>
              <property-view name="Body Type" v-if="security.body">
                {{ security.body }}
              </property-view>
              <property-view name="Value" v-if="security.value > 0">
                {{ security.value | currency }}
              </property-view>
              <property-view name="Condition">
                <template v-if="security.new">
                    New / Demo
                </template>
                <template v-else-if="!security.new && !security.pre_approval">
                    Used
                </template>
                <template v-else-if="security.pre_approval">
                    Pre-Approval
                </template>
              </property-view>
              <property-view name="Make Year" v-if="security.make_year">
                {{ security.make_year }}
              </property-view>
              <property-view name="Model Year" v-if="security.model_year">
                {{ security.model_year }}
              </property-view>
              <property-view name="Make" v-if="security.make">
                {{ security.make }}
              </property-view>
              <property-view name="Model" v-if="security.model">
                {{ security.model }}
              </property-view>
              <property-view name="Odometer" v-if="security.odometer > 0">
                {{ security.odometer }} km
              </property-view>
              <property-view name="Registration" v-if="(security.registration != null || security.state != null)">
                {{ security.registration }} ({{ security.state }})
              </property-view>
              <property-view name="VIN" v-if="security.vin">
                {{ security.vin }}
              </property-view>
              <property-view name="NVIC" v-if="security.nvic">
                {{ security.nvic }}
              </property-view>
              <property-view name="Sale" v-if="security.sale > 0">
                {{ security.sale }}
              </property-view>
              <property-view name="Purchase Cost" v-if="security.purchase_cost > 0">
                {{ security.purchase_cost | currency }}
              </property-view>
              <property-view name="Extras Cost" v-if="security.accessories_cost > 0">
                {{ security.accessories_cost | currency }}
              </property-view>
              <property-view name="Deposit" v-if="security.deposit_value > 0">
                {{ security.deposit_value | currency }}
              </property-view>
              <property-view name="Description" v-if="security.description">
                {{ security.description }}
              </property-view>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Vehicle PPSR Details" v-if="security.ppsr">
          <template v-slot:content>
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <property-view right name="Identifier Number" width="100%">
                  {{ security.ppsr.vehicle_details.identifier_number }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Identifier Type" width="100%">
                  {{ security.ppsr.vehicle_details.identifier_type }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Vehicle Type" width="100%">
                  {{ security.ppsr.vehicle_details.vehicle_type }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Make" width="100%">
                  {{ security.ppsr.vehicle_details.make }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Body Type" width="100%">
                  {{ security.ppsr.vehicle_details.body_type }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Model" width="100%">
                  {{ security.ppsr.vehicle_details.model }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Colour" width="100%">
                  {{ security.ppsr.vehicle_details.colour }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Engine Number" width="100%">
                  {{ security.ppsr.vehicle_details.engine_number }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Registration Plate Number" width="100%">
                  {{ security.ppsr.vehicle_details.registration_plate_number }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="State Vehicle Registered" width="100%">
                  {{ security.ppsr.vehicle_details.registration_state }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Registration Expiry" width="100%">
                  {{ security.ppsr.vehicle_details.registration_expiry }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Year of Manufacture" width="100%">
                  {{ security.ppsr.vehicle_details.manufacture_year.length > 0 ? security.ppsr.vehicle_details.manufacture_year : '' }}
                </property-view>
              </div>
              <div class="md-layout-item md-size-50">
                <property-view right name="Year/Month of Compliance" width="100%">
                  {{ security.ppsr.vehicle_details.compliance }}
                </property-view>
              </div>
            </div>
          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Vehicle PPSR Others" v-if="security.ppsr">
          <template v-slot:content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <traffic-light-card
                  title="Secured Party Details - Organisation Info"
                  :status="getTrafficLight(security.ppsr.secured_party_details.organisation_name.length > 0 ? security.ppsr.secured_party_details.organisation_name : (security.ppsr.secured_party_details.organisation_identifier.length > 0 ? security.ppsr.secured_party_details.organisation_identifier : ''))">

                  {{ security.ppsr.secured_party_details.organisation_name.length > 0 ?
                  security.ppsr.secured_party_details.organisation_name.length : (security.ppsr.secured_party_details.organisation_identifier.length > 0 ? security.ppsr.secured_party_details.organisation_identifier : 'No') }}

                </traffic-light-card>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <traffic-light-card
                  title="NEVDIS Written-off Vehicle Notification"
                  :status="getTrafficLight(security.ppsr.nevdis_written_off_vehicle_notification)"
                >
                  <traffic-light-item>
                    {{ security.ppsr.nevdis_written_off_vehicle_notification.length > 0 ? security.ppsr.nevdis_written_off_vehicle_notification : 'No' }}
                  </traffic-light-item>
                </traffic-light-card>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <traffic-light-card
                  title="NEVDIS Stolen Vehicle Notification"
                  :status="getTrafficLight(security.ppsr.nevdis_stolen_vehicle_notification)"
                >
                  <traffic-light-item>
                    {{ security.ppsr.nevdis_stolen_vehicle_notification.length > 0 ? security.ppsr.nevdis_stolen_vehicle_notification : 'No' }}
                  </traffic-light-item>
                </traffic-light-card>
              </div>
            </div>
          </template>

          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row action>
          <template v-slot:content>

            <div class="md-layout-item md-size-100" >
              <md-button class="md-primary md-sm" @click="onEditApplication('loan_details')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

      </group-card>

      <group-card title="Veda Report" icon="analytics" class="print-hide">

        <group-card-row title="Traffic Lights">
          <template v-slot:content>

          <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">

            <veda-summary v-if="applicant.veda_report" :veda-report="applicant.veda_report" />

          </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item md-size-50"
              v-for="(applicant, index) of application.applicants"
              v-bind:key="index">
              <!-- <md-button class="md-primary md-sm">Full Report</md-button> -->
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

      </group-card>


      <group-card title="Capacity Analysis" icon="attach_money">
        <md-tabs v-if="application.applicants" md-dynamic-height>
          <md-tab
            v-for="(applicant, index) in application.applicants"
            :md-label="'Applicant ' + (index + 1)"
            :key="String(applicant.id)"
            :id="String(applicant.id)"
          >
            <capacity-analysis-component :application="application" v-model="application.applicants[index]" />
          </md-tab>
        </md-tabs>
      </group-card>

      <hr>

      <group-card title="Personal Details" icon="face">

        <group-card-row title="Name">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <h4>
                {{ applicant.contact.name.title }}
                {{ applicant.contact.name.firstname }}
                {{ applicant.contact.name.middlename }}
                {{ applicant.contact.name.lastname }}
              </h4>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Contact">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
              v-for="(applicant, index) of application.applicants"
              v-bind:key="index">

              <div class="property-list">
                <property-view name="Contact Phone">
                  {{ applicant.contact.phones[0].phone_number }}
                </property-view>

                <property-view name="Phone Type">
                  {{ applicant.contact.phones[0].type }}
                </property-view>

                <property-view name="Email">
                  {{ applicant.contact.emails[0].email }}
                </property-view>
              </div>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Details">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">

              <div class="property-list">

                <property-view name="Gender">
                  {{ applicant.contact.gender }}
                </property-view>

                <property-view name="DOB">
                  {{ applicant.contact.date_of_birth }}
                </property-view>

                <property-view name="Residency">
                  {{ applicant.personal_details.residency }}
                </property-view>

                <property-view name="Marital Status">
                  {{ applicant.personal_details.marital_status }}
                </property-view>

                <property-view name="No. Dependants">
                  {{ applicant.personal_details.number_of_dependants }}
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation>
            <p v-for="note of validation.contact_details.age.notes">
              <note-view status="bad">{{ note }}</note-view>
            </p>
          </template>
        </group-card-row>

        <group-card-row title="Spouses Details" v-if="validation.contact_details.to_show_spouse_details">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
              v-for="(applicant, index) of application.applicants"
              v-bind:key="index">

              <div class="property-list">
                <property-view name="Name" width="100%">
                  {{ applicant.personal_details.spouse.name.title }}
                  {{ applicant.personal_details.spouse.name.firstname }}
                  {{ applicant.personal_details.spouse.name.middlename }}
                  {{ applicant.personal_details.spouse.name.lastname }}
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Identification">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
              v-for="(applicant, index) of application.applicants"
              v-bind:key="index">

              <div class="property-list">
                <property-view name="Type">
                  {{ applicant.personal_details.identifications[0].type }}
                </property-view>

                <property-view name="License Type" v-if="applicant.personal_details.identifications[0].type == 'License'">
                  {{ applicant.personal_details.identifications[0].license_type }}
                </property-view>

                <property-view name="ID number">
                  {{ applicant.personal_details.identifications[0].id_number }}
                </property-view>

                <property-view name="Card number">
                  {{ applicant.personal_details.identifications[0].card_number }}
                </property-view>

                <property-view name="Expiry date">
                  {{ applicant.personal_details.identifications[0].expiry_date }}
                </property-view>

                <property-view name="State of issue">
                  {{ applicant.personal_details.identifications[0].state_of_issue }}
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row action>
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <md-button class="md-primary md-sm" @click="onEditApplication('personal_details')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

      </group-card>

      <group-card title="Addresses" icon="location_on">

        <group-card-row title="Current">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">
                      <table class="data-table wide">
                        <colgroup>
                            <col style="width: 100px;">
                            <col>
                            <col style="width: 100px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th><code>Type</code></th>
                            <th><code>Address</code></th>
                            <th><code>Duration</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ applicant.addresses.current.address.type }}</td>
                            <td>{{ applicant.addresses.current.address.full_address }}</td>
                            <td>{{ applicant.addresses.current.duration.years }}y {{ applicant.addresses.current.duration.months }}m</td>
                          </tr>
                        </tbody>
                      </table>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>
        <group-card-row title="Land Title Search Result" v-for="(applicant, index) of application.applicants" :key="index">
          <template v-slot:content>
            <div v-if="index === 0 && applicant.addresses.land_title && applicant.addresses.land_title.length > 0">
              <div class="md-layout bottom-div" v-for="land_title in applicant.addresses.land_title">
                <div class="md-layout-item md-size-100">
                  <property-view right name="State Terrirory Land Registry" width="100%">
                    {{ land_title.state_territory_land_registry }}
                  </property-view>
                </div>
                <div class="md-layout-item md-size-100">
                  <property-view right name="Title Reference" width="100%">
                    {{ land_title.title_reference }}
                  </property-view>
                </div>
                <div class="md-layout-item md-size-100">
                  <property-view right name="Title Description" width="100%">
                    {{ land_title.title_description }}
                  </property-view>
                </div>
              </div>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Landlord" v-if="validation.addresses.to_show_rent_details">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">

              <div class="property-list" v-if="isAddressRentLike(applicant.addresses.current)">
                <property-view name="Name" style="padding-left: 16px;">
                  {{ applicant.addresses.current.landlord.name | name }}
                </property-view>

                <property-view name="Phone Number" style="padding-left: 16px;">
                  {{ applicant.addresses.current.landlord.phone_number }}
                </property-view>

                <property-view name="Address" width="100%" style="padding-left: 16px;">
                  {{ applicant.addresses.current.landlord.address.full_address }}
                </property-view>
              </div>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row title="Previous">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">
                      <table class="data-table wide">
                        <colgroup>
                            <col style="width: 100px;">
                            <col>
                            <col style="width: 100px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th><code>Type</code></th>
                            <th><code>Address</code></th>
                            <th><code>Duration</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                          v-for="address of applicant.addresses.previous">
                            <td>{{ address.address.type }}</td>
                            <td>{{ address.address.full_address }}</td>
                            <td>{{ address.duration.years }}y {{ address.duration.months }}m</td>
                          </tr>
                        </tbody>
                      </table>
            </div>

          </template>
          <template v-slot:validation>
            <p v-for="note of validation.addresses.notes">
              <note-view status="bad">{{ note }}</note-view>
            </p>
          </template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <md-button class="md-primary md-sm" @click="onEditApplication('address_details')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Total Duration">
              {{ validation.addresses.total_duration | yearsMonths }}
            </property-view>
          </template>
        </group-card-row>

      </group-card>

      <group-card title="Employment" icon="work">

        <group-card-row title="Current">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">

              <div class="property-list bottom-div" v-for="employment of applicant.employments.current" >
                <property-view name="Type">
                  {{ employment.type }}
                </property-view>
                <property-view name="Industry">
                  {{ employment.industry }}
                </property-view>
                <property-view name="Occupation">
                  {{ employment.occupation }}
                </property-view>
                <property-view name="Title">
                  {{ employment.title }}
                </property-view>
                <property-view name="Employer">
                  {{ employment.employer_details.name }}
                </property-view>
                <property-view name="ABN">
                  {{ employment.employer_details.abn }}
                </property-view>
                <property-view name="Contact Name">
                  {{ employment.employer_details.contact_name }}
                </property-view>
                <property-view name="Contact Phone">
                  {{ employment.employer_details.contact_number }}
                </property-view>
                <property-view name="Duration">
                  {{ employment.duration.years }}y {{ employment.duration.months }}m
                </property-view>
                <property-view name="Probation">
                  {{ employment.probation == 1 ? 'Yes' :'No'}}
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Max Duration">
              {{ validation.employments.max_current_durations |  yearsMonths }}
            </property-view>
            <div v-for="(applicant, index) of application.applicants" v-bind:key="index">
              <div v-for="(employment, indexkey) of applicant.employments.current" v-bind:key="indexkey">
                <property-view :name_applicant="index+1" v-if="validation.employments.max_current_durations == ((applicant.employments.current[indexkey].duration.years * 12) + Number(employment.duration.months))">
                  {{ applicant.employments.current[indexkey].type }}
                </property-view>
              </div>
            </div>
          </template>
        </group-card-row>

        <group-card-row title="Spouse" v-if="validation.contact_details.to_show_spouse_details">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">

              <div class="property-list bottom-div">
                <property-view name="Type">
                  {{ applicant.personal_details.spouse.employment.type }}
                </property-view>
                <property-view name="Employer">
                  {{ applicant.personal_details.spouse.employment.employer_name }}
                </property-view>
                <property-view name="Duration">
                  {{ applicant.personal_details.spouse.employment.duration.years }}y {{ applicant.personal_details.spouse.employment.duration.months }}m
                </property-view>
                <property-view name="Income">
                  {{ toMonthlyAmount(applicant.personal_details.spouse.employment.income.amount, applicant.personal_details.spouse.employment.income.frequency) | currency }} / m
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation>
            <br/>
            <br/>
            <br/>
            <property-view name="Spouse Total Income" class="width-300px">
              {{ validation.employments.spouse_income | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row title="Previous">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">

              <div class="property-list bottom-div" v-for="employment of applicant.employments.previous" >
                <property-view name="Type">
                  {{ employment.type }}
                </property-view>
                <property-view name="Industry">
                  {{ employment.industry }}
                </property-view>
                <property-view name="Occupation">
                  {{ employment.occupation }}
                </property-view>
                <property-view name="Title">
                  {{ employment.title }}
                </property-view>
                <property-view name="Employer">
                  {{ employment.employer_details.name }}
                </property-view>
                <property-view name="ABN">
                  {{ employment.employer_details.abn }}
                </property-view>
                <property-view name="Contact Name">
                  {{ employment.employer_details.contact_name }}
                </property-view>
                <property-view name="Contact Phone">
                  {{ employment.employer_details.contact_number }}
                </property-view>
                <property-view name="Duration">
                  {{ employment.duration.years }}y {{ employment.duration.months }}m
                </property-view>
              </div>

            </div>
          </template>
          <template v-slot:validation>
          </template>
        </group-card-row>

        <group-card-row action>
          <template v-slot:content>
            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <md-button class="md-primary md-sm" @click="onEditApplication('employee_details')">Edit</md-button>
            </div>
          </template>
          <template v-slot:validation>
            <property-view name="Grand Total Duration">
              {{ validation.employments.continuus_durations | yearsMonths }}
            </property-view>
          </template>
        </group-card-row>

      </group-card>

      <group-card title="Income Summary" icon="attach_money">

        <group-card-row title="Employment">
          <template v-slot:content>
            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">

                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Employer</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="employment of applicant.employments.current">
                            <td>              {{ employment.employer_details.name }}</td>
                            <td class="right">{{ employment.income.amount | currency }}</td>
                            <td>              {{ employment.income.frequency }}</td>
                            <td class="right">{{ toMonthlyAmount(employment.income.amount, employment.income.frequency) | currency }}</td>
                          </tr>
                        </tbody>
                      </table>

            </div>
          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.employments.income | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row title="Asset">
          <template v-slot:content>
            <div class="md-layout-item md-size-100"
              v-for="applicant of [application.applicants[0]]">

                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Type</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="asset of applicant.assets">
                            <tr v-if="asset.income.amount > 0">
                              <td>              {{ asset.type }}</td>
                              <td class="right">{{ asset.income.amount | currency }}</td>
                              <td>              {{ asset.income.frequency }}</td>
                              <td class="right">{{ toMonthlyAmount(asset.income.amount, asset.income.frequency) | currency }}</td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
            </div>
          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.assets.income | currency }} / m
            </property-view></template>
        </group-card-row>

        <group-card-row title="Other">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">
                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Type</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="income of applicant.incomes">
                            <td>              {{ income.type }}</td>
                            <td class="right">{{ income.amount | currency }}</td>
                            <td>              {{ income.frequency }}</td>
                            <td class="right">{{ toMonthlyAmount(income.amount, income.frequency) | currency }}</td>
                          </tr>
                        </tbody>
                      </table>
            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.otherIncomes.total | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row title="Spouse">
          <template v-slot:content>
            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">

                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Type</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                            <th>              <code>Employer</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="hasSpouse(applicant.personal_details)">
                            <td>              {{ applicant.personal_details.spouse.employment.type }}</td>
                            <td class="right">{{ applicant.personal_details.spouse.employment.income.amount | currency }}</td>
                            <td>              {{ applicant.personal_details.spouse.employment.income.frequency }}</td>
                            <td class="right">{{ toMonthlyAmount(applicant.personal_details.spouse.employment.income.amount, applicant.personal_details.spouse.employment.income.frequency) | currency }}</td>
                            <td>              {{ applicant.personal_details.spouse.employment.employer_name }}</td>
                          </tr>
                        </tbody>
                      </table>

            </div>
          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.employments.spouse_income | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">
              <md-button class="md-primary md-sm" @click="onEditApplication('income_summary')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation>

            <property-view name="Grand Total">
              {{ validation.capacity.income | currency }} / m
            </property-view>

          </template>
        </group-card-row>

      </group-card>

      <group-card title="Expense Summary" icon="credit_card">

        <group-card-row title="Living">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">
                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Type</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                          v-for="(expense, index) of applicant.expenses"
                          v-bind:key="index">
                            <td>              {{ expense.type }}</td>
                            <td class="right">{{ expense.amount | currency }}</td>
                            <td>              {{ expense.frequency }}</td>
                            <td class="right">{{ toMonthlyAmount(expense.amount, expense.frequency) | currency }}</td>
                          </tr>
                        </tbody>
                      </table>
            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.expenses.total | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row title="Asset & Liability">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">

                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Type</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="asset of applicant.assets">
                            <tr v-if="asset.expense.amount > 0 && asset.has_liability == true">
                              <td>              {{ asset.type }}</td>
                              <td class="right">{{ asset.expense.amount | currency }}</td>
                              <td>              {{ asset.expense.frequency }}</td>
                              <td class="right">{{ toMonthlyAmount(asset.expense.amount, asset.expense.frequency) | currency }}</td>
                            </tr>
                          </template>
                        </tbody>
                      </table>

            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.assets.expense | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row title="Rent">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
              v-for="applicant of application.applicants">

                      <table class="data-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 120px;">
                            <col style="width: 150px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>              <code>Type</code></th>
                            <th class="right"><code>Amount</code></th>
                            <th>              <code>Frequency</code></th>
                            <th class="right"><code>Monthly</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="isAddressRentLike(applicant.addresses.current)">
                            <td>              {{ applicant.addresses.current.ownership }}</td>
                            <td class="right">{{ applicant.addresses.current.expense.amount | currency }}</td>
                            <td>              {{ applicant.addresses.current.expense.frequency }}</td>
                            <td class="right">{{ toMonthlyAmount(applicant.addresses.current.expense.amount, applicant.addresses.current.expense.frequency) | currency }}</td>
                          </tr>
                        </tbody>
                      </table>

            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Total">
              {{ validation.addresses.expense | currency }} / m
            </property-view>
          </template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <md-button class="md-primary md-sm" @click="onEditApplication('expense_summary')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation>

            <property-view name="Grand Total">
              {{ validation.capacity.expense | currency }} / m
            </property-view>

          </template>
        </group-card-row>

      </group-card>

      <group-card title="Assets & Liabilities" icon="house">

        <group-card-row title="Assets, Liabilities and Incomes">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="(applicant, index) of application.applicants">
              <div class="property-list bottom-div" v-for="asset of applicant.assets">
                <property-view name="Type" v-if="asset.type">
                  {{ asset.type }}
                </property-view>
                <property-view name="Value" v-if="asset.value && asset.type != 'Credit Card'">
                  {{ asset.value | currency }}
                </property-view>
                <property-view name="Description" v-if="asset.description && asset.type != 'Credit Card'">
                  {{ asset.description }}
                </property-view>
                <template v-if="(asset.has_liability == true)">
                  <property-view name="Provider" v-if="asset.finance.provider">
                    {{ asset.finance.provider }}
                  </property-view>
                  <property-view name="Outstanding" v-if="asset.finance.outstanding_amount">
                    {{ asset.finance.outstanding_amount | currency }}
                  </property-view>
                  <property-view name="Limit" v-if="asset.finance.original_amount">
                    {{ asset.finance.original_amount | currency }}
                  </property-view>
                  <property-view name="Remaining" v-if="(asset.finance.duration.years > 0 || asset.finance.duration.months > 0)  && asset.type !='Credit Card'">
                    {{ asset.finance.duration.years }}y {{ asset.finance.duration.months }}m
                  </property-view>
                </template>
                <property-view name="Repayments" v-if="toMonthlyAmount(asset.expense.amount, asset.expense.frequency) > 0 && asset.has_liability == true">
                  {{ toMonthlyAmount(asset.expense.amount, asset.expense.frequency) | currency }} / m
                </property-view>
                <property-view name="Income" v-if="toMonthlyAmount(asset.income.amount, asset.income.frequency) > 0 && asset.has_income == true">
                  {{ toMonthlyAmount(asset.income.amount, asset.income.frequency) | currency }} / m
                </property-view>
                <property-view name="Trade In" v-if="asset.has_trade_in == true">
                  True
                </property-view>
                <property-view name="Comment" v-if="asset.comment">
                  {{ asset.comment }}
                </property-view>

              </div>

            </div>

          </template>
          <template v-slot:validation>
            <property-view name="Total Value" v-if="validation.assets.total > 0" class="width-100">   {{ validation.assets.total   | currency }} </property-view>
            <property-view name="Total Income" v-if="validation.assets.income > 0 && validation.assets.has_incomes > 0" class="width-100">  {{ validation.assets.income  | currency }} / m </property-view>
            <property-view name="Total Expenses" v-if="validation.assets.expense > 0 && validation.assets.has_liability > 0" class="width-100">{{ validation.assets.expense | currency }} / m </property-view>
          </template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item md-size-50" v-for="applicant of application.applicants">
              <md-button class="md-primary md-sm" @click="onEditApplication('assets_liabilities_details')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation>
          </template>
        </group-card-row>

      </group-card>



      <group-card title="References" icon="contacts">

        <group-card-row title="References">
          <template v-slot:content>

            <div class="md-layout-item" :class="content_class"
            v-for="applicant of application.applicants">

              <div class="property-list" v-for="reference of applicant.references" >
                <property-view width="250px" name="Relationship">
                  {{ reference.relationship }}
                </property-view>
                <property-view width="250px" name="Name">
                  {{ reference.name }}
                </property-view>
                <property-view width="250px" name="Phone Number">
                  {{ reference.phone }}
                </property-view>
                <property-view width="250px" name="Email">
                  {{ reference.email }}
                </property-view>
                <property-view width="250px" name="Contact Hours">
                  {{ reference.contact_hours }}
                </property-view>
                <property-view width="250px" name="Comment">
                  {{ reference.comment }}
                </property-view>
              </div>

            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item md-size-50"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <md-button class="md-primary md-sm" @click="onEditApplication('references')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

      </group-card>

      <group-card title="Comments" icon="comment">

        <group-card-row title="Comments">
          <template v-slot:content>

            <div class="md-layout-item md-size-100" >

                      <table class="data-table">
                        <colgroup>
                            <col style="width: 200px;">
                            <col style="width: 310px;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th><code>Tag</code></th>
                            <th><code>Comment</code></th>
                            <th><code>Time</code></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="comment of application.loan.app_status_comments">
                            <td>Status Comment</td>
                            <td>{{ comment.content }}</td>
                            <td>{{ comment.created_at | datetime }}</td>
                          </tr>
                          <tr v-for="comment of application.loan.comments">
                            <td>{{ comment.tag }}</td>
                            <td>{{ comment.content }}</td>
                            <td>{{ comment.created_at | datetime }}</td>
                          </tr>
                        </tbody>
                      </table>

            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

        <group-card-row action>

          <template v-slot:content>

            <div class="md-layout-item md-size-50"
            v-for="(applicant, index) of application.applicants"
            v-bind:key="index">
              <md-button class="md-primary md-sm" @click="onEditApplication('comments')">Edit</md-button>
            </div>

          </template>
          <template v-slot:validation></template>
        </group-card-row>

      </group-card>
      <floating-comment-section v-model="application" :available-sections="availableSections" :current-sections="currentSections" />
  </div>

  <div v-else-if="application_status.loading">
    <md-empty-state
      md-icon="hourglass_empty"
      md-label="Loading"
      md-description="Please wait whilst the application is loading"
      />
  </div>

  <div v-else>
    <md-empty-state
      md-icon="close"
      md-label="No Application selected"
      md-description="Go to the Dashboard and select an application."
      />
  </div>

</template>
<script>
import { mapGetters } from 'vuex';
import { Badge } from "@/components";
import { GroupCard } from "@/components";
import { GroupCardRow } from "@/components";
import { PropertyView } from "@/components";
import { NoteView } from "@/components";
import VedaSummary from '@/components/ApplicationSummary/VedaSummary.vue';
import FloatingCommentSection from '@/components/Editors/FloatingCommentSection';

import filters from "@/components/utils/filters";
import { applicationValidation, isAddressRentLike, hasSpouse } from "@/components/utils/validation";
import TrafficLightCard from '@/components/Cards/TrafficLightCard';
import TrafficLightItem from '@/components/Cards/TrafficLightItem';
import CapacityAnalysisComponent from "@/components/CapacityAnalysis/CapacityAnalysisComponent.vue";

export default {
  components: {
    CapacityAnalysisComponent,
    Badge,
    GroupCard,
    GroupCardRow,
    PropertyView,
    NoteView,
    VedaSummary,
    TrafficLightCard,
    TrafficLightItem,
    FloatingCommentSection,
  },
  data() {
    return {
      selected_veda_details: '',
      availableSections: [
        'Summary',
        'Wallet Notification'
      ],
      currentSections: 'Summary'
    };
  },
  props: {
    // data: Object,
  },
  computed: {
    ...mapGetters([
      'application',
      'application_status',
      'security',
      "options",
    ]),
    content_class(){
      switch(this.application.applicants.length){
        case  1: return 'md-size-100'; break;
        // case  1: return 'md-size-50'; break;
        case  2: return 'md-size-50'; break;
        case  3: return 'md-size-33'; break;
        default: return 'md-size-50'; break;
      }
    },
    validation(){
      return applicationValidation(this.application);
    },
    hasAnyRentLikeAddresses(){
      return this.validation.addresses.expense > 0;
    },
    requested_amount() {
      return this.security.requested_amount;
    },
  },
  methods: {
    ...filters,
    isAddressRentLike,
    hasSpouse,

    toggleSelectedDetails(selection){
      if(this.selected_veda_details == selection)
        this.selected_veda_details = '';
      else
        this.selected_veda_details = selection;
    },

    getTrafficLight(param) {
      if (param.length > 0) {
        return 'bad';
      }
      return 'good';
    },
    onEditApplication(refervalue){
      this.$router.push({path: '/application/' + this.application.loan.id + '/capture', hash: '#' + refervalue});
    },
  },
  filters: {
    ...filters,
  },
  beforeMount() {
    this.application_data = this.$store.getters.getApplication();
  },
  async beforeCreate() {
    const params = {
      types: [
        'assets_sale_types',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>

<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";

  table.border-less-spaced th, table.border-less-spaced td{
    text-align: start;
    padding-right: 20px;
  }
  table .row-group-end td{
    padding-bottom: 15px;
  }
  h6{
    font-weight: bold;
  }
  .bottom-div{
    border-bottom: 1px solid rgba(0,0,0,0.2);
    margin-bottom: 15px;
  }
  .property-list{
    padding-bottom: 15px;
  }
  .width-100{
    width: 100% !important;
    font-size: 0.8rem !important;
  }
  .md-layout.no-pad .md-layout-item{
    padding: 0px;
  }
  .light{
    color: $color-text-light;
  }
  .font-weight-bold{
    font-weight: 700;
  }
  .mr-2{
    margin-right: 10px;
  }
  .min-height-60{
    min-height: 60px;
  }
  .width-300px{
    width: 300px !important;
  }
</style>
